import { bff, toClientError } from './bff'

const run = (p) => p.then((r) => r.data).catch((e) => Promise.reject(toClientError(e)))

// ---- session ----
// getMe is the SPA's boot probe: it answers "is auth even on", "who am I", and
// "does this instance still need its first account" in one call.
export const getMe = () => run(bff.get('/api/auth/me'))
export const login = (username, password) => run(bff.post('/api/auth/login', { username, password }))
export const logout = () => run(bff.post('/api/auth/logout', {}))
export const setup = ({ username, password, display_name }) =>
  run(bff.post('/api/auth/setup', { username, password, display_name }))
export const changePassword = (current_password, new_password) =>
  run(bff.post('/api/auth/password', { current_password, new_password }))

// ---- administration (admin role) ----
export const listUsers = () => run(bff.get('/api/auth/users'))
export const createUser = (body) => run(bff.post('/api/auth/users', body))
export const patchUser = (id, patch) => run(bff.patch(`/api/auth/users/${id}`, patch))
export const resetUserPassword = (id, password) =>
  run(bff.post(`/api/auth/users/${id}/password`, { password }))
export const listAuthEvents = (limit = 100) =>
  run(bff.get('/api/auth/events', { params: { limit } }))

// ---- API tokens ----
export const listTokens = () => run(bff.get('/api/auth/tokens'))
// The secret comes back exactly once — the server keeps only a hash.
export const createToken = (name) => run(bff.post('/api/auth/tokens', { name }))
export const revokeToken = (id) => run(bff.delete(`/api/auth/tokens/${id}`))
